/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".timer[_ngcontent-%COMP%]{display:block;margin:30px 0;text-align:center;font-size:50px;font-weight:300;font-family:Lato,sans-serif}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/rec/components/timer/timer.component.styl.shim.ngstyle.js.pre-build-optimizer.js